import { render } from "./ProductSlide.vue?vue&type=template&id=1497d2b6"
import script from "./ProductSlide.vue?vue&type=script&lang=js"
export * from "./ProductSlide.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__